import { faXmarkLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@sharedComponents/Button';
import FlexBox from '@sharedComponents/FlexBox';
import Overlay from '@sharedComponents/Overlay';
import Typography from '@sharedComponents/Typography';
import { useEffect } from 'react';

import * as style from './style.module.css';

const Sidebar = ({ children, title = '', subtitle = '', isOpened = false, onClose = () => {}, isClosable = true, subtitleIcon = null }) => {
    useEffect(() => {
        document.body.style.overflow = isOpened ? 'hidden' : 'unset';
        return () => (document.body.style.overflow = 'unset');
    }, [isOpened]);

    return (
        <>
            <Overlay isOpen={isOpened} zIndex={999999996} onClose={() => isClosable && onClose()} />
            <div className={`${style.sidebar} ${isOpened ? style.isOpen : ''}`}>
                {isClosable && (
                    <div className={style.titleContainer}>
                        <FlexBox flexDirection="column">
                            <Typography color="neutral-primary" fontWeight="semi-bold" fontSize="xl">
                                {title}
                            </Typography>
                            <FlexBox flexDirection="row" gap="xs" alignItems="center">
                                {subtitleIcon && <FontAwesomeIcon className={style.subtitleIcon} icon={subtitleIcon} size="lg" />}
                                <Typography color="neutral-primary" fontWeight="regular" fontSize="l">
                                    {subtitle}
                                </Typography>
                            </FlexBox>
                        </FlexBox>
                        <Button action={onClose} icon={faXmarkLarge} ghost />
                    </div>
                )}
                {children}
            </div>
        </>
    );
};

export default Sidebar;
